<template>
	<article class="small-12" v-highlight v-if="event">
        <pre class="flex">
            <code class="json" v-if="event.attributes.response.attributes.line_items.length == 1">
{
    created_at: "{{event.meta.created_at | unixToDateTime}}",
    version: 1,
    body: {
        status: "{{event.attributes.response.attributes.status}}",
        collection_method: "{{event.attributes.response.attributes.collection_method}}",
        proration: {
            prorated: {{event.attributes.response.attributes.proration.prorated}},
            amount: {{event.attributes.response.attributes.proration.amount | convertCentsToDollars}}
        },
        due_on: {
            date: "{{event.attributes.response.attributes.due_on.date | unixToDateTime}}"
        },
        late_policy: {
            date: "{{event.attributes.response.attributes.late_policy.date | unixToDateTime}}"
        },
        notification: {
            date: "{{event.attributes.response.attributes.notification.date | unixToDateTime}}",
            days_in_advance: {{event.attributes.response.attributes.notification.days_in_advance}}
        },
        description: "{{event.attributes.response.attributes.description}}",
        charge: {
            currency: "{{event.attributes.response.attributes.charge.currency}}",
            policy_late_fee: {{event.attributes.response.attributes.charge.policy_late_fee | convertCentsToDollars}},
            rent_amount: {{event.attributes.response.attributes.charge.amount | convertCentsToDollars}},
            subtotal: {{event.attributes.response.attributes.charge.subtotal | convertCentsToDollars}},
            total: {{event.attributes.response.attributes.charge.total | convertCentsToDollars}},
            total_paid: {{event.attributes.response.attributes.charge.total_paid | convertCentsToDollars}},
            tax: {{event.attributes.response.attributes.charge.tax | convertCentsToDollars}},
            electronic_payments_transaction_fee: {{event.attributes.response.attributes.charge.transaction_fee | convertCentsToDollars}}
        },
        line_items: [
            {
                amount: {{event.attributes.response.attributes.line_items[0].amount | convertCentsToDollars}},
                type: "{{event.attributes.response.attributes.line_items[0].type}}", 
                description: "{{event.attributes.response.attributes.line_items[0].description}}",
                paid: {{event.attributes.response.attributes.line_items[0].paid}},
                paid_amount: {{event.attributes.response.attributes.line_items[0].paid_amount | convertCentsToDollars}}
            }
        ]
    }
}
            </code>
            <code class="json" v-if="event.attributes.response.attributes.line_items.length == 2">
{
    created_at: "{{event.meta.created_at | unixToDateTime}}",
    version: 1,
    body: {
        status: "{{event.attributes.response.attributes.status}}",
        collection_method: "{{event.attributes.response.attributes.collection_method}}",
        proration: {
            prorated: {{event.attributes.response.attributes.proration.prorated}},
            amount: {{event.attributes.response.attributes.proration.amount | convertCentsToDollars}}
        },
        due_on: {
            date: "{{event.attributes.response.attributes.due_on.date | unixToDateTime}}"
        },
        late_policy: {
            date: "{{event.attributes.response.attributes.late_policy.date | unixToDateTime}}"
        },
        notification: {
            date: "{{event.attributes.response.attributes.notification.date | unixToDateTime}}",
            days_in_advance: {{event.attributes.response.attributes.notification.days_in_advance}}
        },
        description: "{{event.attributes.response.attributes.description}}",
        charge: {
            currency: "{{event.attributes.response.attributes.charge.currency}}",
            policy_late_fee: {{event.attributes.response.attributes.charge.policy_late_fee | convertCentsToDollars}},
            rent_amount: {{event.attributes.response.attributes.charge.amount | convertCentsToDollars}},
            subtotal: {{event.attributes.response.attributes.charge.subtotal | convertCentsToDollars}},
            total: {{event.attributes.response.attributes.charge.total | convertCentsToDollars}},
            total_paid: {{event.attributes.response.attributes.charge.total_paid | convertCentsToDollars}},
            tax: {{event.attributes.response.attributes.charge.tax | convertCentsToDollars}},
            electronic_payments_transaction_fee: {{event.attributes.response.attributes.charge.transaction_fee | convertCentsToDollars}}
        },
        line_items: [
            {
                amount: {{event.attributes.response.attributes.line_items[0].amount | convertCentsToDollars}},
                type: "{{event.attributes.response.attributes.line_items[0].type}}", 
                description: "{{event.attributes.response.attributes.line_items[0].description}}",
                paid: {{event.attributes.response.attributes.line_items[0].paid}},
                paid_amount: {{event.attributes.response.attributes.line_items[0].paid_amount | convertCentsToDollars}}
            },
            {
                amount: {{event.attributes.response.attributes.line_items[1].amount | convertCentsToDollars}},
                type: "{{event.attributes.response.attributes.line_items[1].type}}", 
                description: "{{event.attributes.response.attributes.line_items[1].description}}",
                paid: {{event.attributes.response.attributes.line_items[1].paid}},
                paid_amount: {{event.attributes.response.attributes.line_items[1].paid_amount | convertCentsToDollars}}
            }
        ]
    }
}
            </code>
            <code class="json" v-if="event.attributes.response.attributes.line_items.length == 3">
{
    created_at: "{{event.meta.created_at | unixToDateTime}}",
    version: 1,
    body: {
        status: "{{event.attributes.response.attributes.status}}",
        collection_method: "{{event.attributes.response.attributes.collection_method}}",
        proration: {
            prorated: {{event.attributes.response.attributes.proration.prorated}},
            amount: {{event.attributes.response.attributes.proration.amount | convertCentsToDollars}}
        },
        due_on: {
            date: "{{event.attributes.response.attributes.due_on.date | unixToDateTime}}"
        },
        late_policy: {
            date: "{{event.attributes.response.attributes.late_policy.date | unixToDateTime}}"
        },
        notification: {
            date: "{{event.attributes.response.attributes.notification.date | unixToDateTime}}",
            days_in_advance: {{event.attributes.response.attributes.notification.days_in_advance}}
        },
        description: "{{event.attributes.response.attributes.description}}",
        charge: {
            currency: "{{event.attributes.response.attributes.charge.currency}}",
            policy_late_fee: {{event.attributes.response.attributes.charge.policy_late_fee | convertCentsToDollars}},
            rent_amount: {{event.attributes.response.attributes.charge.amount | convertCentsToDollars}},
            subtotal: {{event.attributes.response.attributes.charge.subtotal | convertCentsToDollars}},
            total: {{event.attributes.response.attributes.charge.total | convertCentsToDollars}},
            total_paid: {{event.attributes.response.attributes.charge.total_paid | convertCentsToDollars}},
            tax: {{event.attributes.response.attributes.charge.tax | convertCentsToDollars}},
            electronic_payments_transaction_fee: {{event.attributes.response.attributes.charge.transaction_fee | convertCentsToDollars}}
        },
        line_items: [
            {
                amount: {{event.attributes.response.attributes.line_items[0].amount | convertCentsToDollars}},
                type: "{{event.attributes.response.attributes.line_items[0].type}}", 
                description: "{{event.attributes.response.attributes.line_items[0].description}}",
                paid: {{event.attributes.response.attributes.line_items[0].paid}},
                paid_amount: {{event.attributes.response.attributes.line_items[0].paid_amount | convertCentsToDollars}}
            },
            {
                amount: {{event.attributes.response.attributes.line_items[1].amount | convertCentsToDollars}},
                type: "{{event.attributes.response.attributes.line_items[1].type}}", 
                description: "{{event.attributes.response.attributes.line_items[1].description}}",
                paid: {{event.attributes.response.attributes.line_items[1].paid}},
                paid_amount: {{event.attributes.response.attributes.line_items[1].paid_amount | convertCentsToDollars}}
            },
            {
                amount: {{event.attributes.response.attributes.line_items[2].amount | convertCentsToDollars}},
                type: "{{event.attributes.response.attributes.line_items[2].type}}", 
                description: "{{event.attributes.response.attributes.line_items[2].description}}",
                paid: {{event.attributes.response.attributes.line_items[2].paid}},
                paid_amount: {{event.attributes.response.attributes.line_items[2].paid_amount | convertCentsToDollars}}
            }
        ]
    }
}
            </code>
            <code class="json" v-if="event.attributes.response.attributes.line_items.length == 4">
{
    created_at: "{{event.meta.created_at | unixToDateTime}}",
    version: 1,
    body: {
        status: "{{event.attributes.response.attributes.status}}",
        collection_method: "{{event.attributes.response.attributes.collection_method}}",
        proration: {
            prorated: {{event.attributes.response.attributes.proration.prorated}},
            amount: {{event.attributes.response.attributes.proration.amount | convertCentsToDollars}}
        },
        due_on: {
            date: "{{event.attributes.response.attributes.due_on.date | unixToDateTime}}"
        },
        late_policy: {
            date: "{{event.attributes.response.attributes.late_policy.date | unixToDateTime}}"
        },
        notification: {
            date: "{{event.attributes.response.attributes.notification.date | unixToDateTime}}",
            days_in_advance: {{event.attributes.response.attributes.notification.days_in_advance}}
        },
        description: "{{event.attributes.response.attributes.description}}",
        charge: {
            currency: "{{event.attributes.response.attributes.charge.currency}}",
            policy_late_fee: {{event.attributes.response.attributes.charge.policy_late_fee | convertCentsToDollars}},
            rent_amount: {{event.attributes.response.attributes.charge.amount | convertCentsToDollars}},
            subtotal: {{event.attributes.response.attributes.charge.subtotal | convertCentsToDollars}},
            total: {{event.attributes.response.attributes.charge.total | convertCentsToDollars}},
            total_paid: {{event.attributes.response.attributes.charge.total_paid | convertCentsToDollars}},
            tax: {{event.attributes.response.attributes.charge.tax | convertCentsToDollars}},
            electronic_payments_transaction_fee: {{event.attributes.response.attributes.charge.transaction_fee | convertCentsToDollars}}
        },
        line_items: [
            {
                amount: {{event.attributes.response.attributes.line_items[0].amount | convertCentsToDollars}},
                type: "{{event.attributes.response.attributes.line_items[0].type}}", 
                description: "{{event.attributes.response.attributes.line_items[0].description}}",
                paid: {{event.attributes.response.attributes.line_items[0].paid}},
                paid_amount: {{event.attributes.response.attributes.line_items[0].paid_amount | convertCentsToDollars}}
            },
            {
                amount: {{event.attributes.response.attributes.line_items[1].amount | convertCentsToDollars}},
                type: "{{event.attributes.response.attributes.line_items[1].type}}", 
                description: "{{event.attributes.response.attributes.line_items[1].description}}",
                paid: {{event.attributes.response.attributes.line_items[1].paid}},
                paid_amount: {{event.attributes.response.attributes.line_items[1].paid_amount | convertCentsToDollars}}
            },
            {
                amount: {{event.attributes.response.attributes.line_items[2].amount | convertCentsToDollars}},
                type: "{{event.attributes.response.attributes.line_items[2].type}}", 
                description: "{{event.attributes.response.attributes.line_items[2].description}}",
                paid: {{event.attributes.response.attributes.line_items[2].paid}},
                paid_amount: {{event.attributes.response.attributes.line_items[2].paid_amount | convertCentsToDollars}}
            },
            {
                amount: {{event.attributes.response.attributes.line_items[3].amount | convertCentsToDollars}},
                type: "{{event.attributes.response.attributes.line_items[3].type}}", 
                description: "{{event.attributes.response.attributes.line_items[3].description}}",
                paid: {{event.attributes.response.attributes.line_items[3].paid}},
                paid_amount: {{event.attributes.response.attributes.line_items[3].paid_amount | convertCentsToDollars}}
            }
        ]
    }
}
            </code>
            <code class="json" v-if="event.attributes.response.attributes.line_items.length == 5">
{
    created_at: "{{event.meta.created_at | unixToDateTime}}",
    version: 1,
    body: {
        status: "{{event.attributes.response.attributes.status}}",
        collection_method: "{{event.attributes.response.attributes.collection_method}}",
        proration: {
            prorated: {{event.attributes.response.attributes.proration.prorated}},
            amount: {{event.attributes.response.attributes.proration.amount | convertCentsToDollars}}
        },
        due_on: {
            date: "{{event.attributes.response.attributes.due_on.date | unixToDateTime}}"
        },
        late_policy: {
            date: "{{event.attributes.response.attributes.late_policy.date | unixToDateTime}}"
        },
        notification: {
            date: "{{event.attributes.response.attributes.notification.date | unixToDateTime}}",
            days_in_advance: {{event.attributes.response.attributes.notification.days_in_advance}}
        },
        description: "{{event.attributes.response.attributes.description}}",
        charge: {
            currency: "{{event.attributes.response.attributes.charge.currency}}",
            policy_late_fee: {{event.attributes.response.attributes.charge.policy_late_fee | convertCentsToDollars}},
            rent_amount: {{event.attributes.response.attributes.charge.amount | convertCentsToDollars}},
            subtotal: {{event.attributes.response.attributes.charge.subtotal | convertCentsToDollars}},
            total: {{event.attributes.response.attributes.charge.total | convertCentsToDollars}},
            total_paid: {{event.attributes.response.attributes.charge.total_paid | convertCentsToDollars}},
            tax: {{event.attributes.response.attributes.charge.tax | convertCentsToDollars}},
            electronic_payments_transaction_fee: {{event.attributes.response.attributes.charge.transaction_fee | convertCentsToDollars}}
        },
        line_items: [
            {
                amount: {{event.attributes.response.attributes.line_items[0].amount | convertCentsToDollars}},
                type: "{{event.attributes.response.attributes.line_items[0].type}}", 
                description: "{{event.attributes.response.attributes.line_items[0].description}}",
                paid: {{event.attributes.response.attributes.line_items[0].paid}},
                paid_amount: {{event.attributes.response.attributes.line_items[0].paid_amount | convertCentsToDollars}}
            },
            {
                amount: {{event.attributes.response.attributes.line_items[1].amount | convertCentsToDollars}},
                type: "{{event.attributes.response.attributes.line_items[1].type}}", 
                description: "{{event.attributes.response.attributes.line_items[1].description}}",
                paid: {{event.attributes.response.attributes.line_items[1].paid}},
                paid_amount: {{event.attributes.response.attributes.line_items[1].paid_amount | convertCentsToDollars}}
            },
            {
                amount: {{event.attributes.response.attributes.line_items[2].amount | convertCentsToDollars}},
                type: "{{event.attributes.response.attributes.line_items[2].type}}", 
                description: "{{event.attributes.response.attributes.line_items[2].description}}",
                paid: {{event.attributes.response.attributes.line_items[2].paid}},
                paid_amount: {{event.attributes.response.attributes.line_items[2].paid_amount | convertCentsToDollars}}
            },
            {
                amount: {{event.attributes.response.attributes.line_items[3].amount | convertCentsToDollars}},
                type: "{{event.attributes.response.attributes.line_items[3].type}}", 
                description: "{{event.attributes.response.attributes.line_items[3].description}}",
                paid: {{event.attributes.response.attributes.line_items[3].paid}},
                paid_amount: {{event.attributes.response.attributes.line_items[3].paid_amount | convertCentsToDollars}}
            },
            {
                amount: {{event.attributes.response.attributes.line_items[4].amount | convertCentsToDollars}},
                type: "{{event.attributes.response.attributes.line_items[4].type}}", 
                description: "{{event.attributes.response.attributes.line_items[4].description}}",
                paid: {{event.attributes.response.attributes.line_items[4].paid}},
                paid_amount: {{event.attributes.response.attributes.line_items[4].paid_amount | convertCentsToDollars}}
            }
        ]
    }
}
            </code>
        </pre>
	</article>
</template>

<script>

    // Import the mixins
	import { MoneyConversions } from '@/mixins/filters/MoneyConversions'
	import { DatesFilters } from '@/mixins/filters/DatesFilters'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'InvoiceUpdatedEventResponse',

		/*
		**  Register the mixins
		*/

		mixins: [

            MoneyConversions,
            DatesFilters

		],

		/*
		**  Set the props
		*/

		props: {

			event: {
				type: Object,
				default: () => null
			}

		}

	}

</script>